import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';

import { getSelectedProfile } from '../selectors/profiles';

import moment from 'moment';
import jwtDecode from 'jwt-decode';
import BabyEdit from '../components/BabyEdit';
import api from '../api';

function formatValues(values) {
  return {
    ...values,
    dueDate: moment(values.dueDate).format(),
    birthDate: moment(values.birthDate).format()
  };
}
class BabyEditContainer extends Component {
  componentDidMount() {
    this.props.babiesPatchReset({});
  }

  render() {
    const {
      babiesPatch,
      babiesPatchReset,
      accountId,
      baby,
      onCancelClicked
    } = this.props;

    const handleSubmit = values => {
      babiesPatchReset({});

      return babiesPatch(
        { accountId, id: baby.id },
        {
          body: JSON.stringify({
            ...formatValues(values),
            status: 'active'
          })
        }
      )
        .then(() => {
          this.props.onBabySaved();
        })
        .catch(() => {
          throw new SubmissionError({
            _error: 'accountOptions.editBabyError'
          });
        });
    };

    return (
      <BabyEdit
        initialValues={baby}
        onSubmit={handleSubmit}
        onCancelClicked={onCancelClicked}
      />
    );
  }
}

BabyEditContainer.propTypes = {
  babiesPatch: PropTypes.func.isRequired,
  babiesPatchReset: PropTypes.func.isRequired,
  onBabySaved: PropTypes.func.isRequired,
  onCancelClicked: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
  baby: PropTypes.shape({
    name: PropTypes.string,
    sex: PropTypes.oneOf(['M', 'F', 'O']),
    room: PropTypes.string,
    dueDate: PropTypes.string,
    birthDate: PropTypes.string,
    icon: PropTypes.string
  }).isRequired
};

function mapStateToProps(state, ownProps) {
  const { accountId } = jwtDecode(state.auth.token);
  return {
    accountId,
    selectedProfile: getSelectedProfile(state),
    ...ownProps
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      babiesPatch: api.actions.babiesPatch,
      babiesPatchReset: api.actions.babiesPatch.reset
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BabyEditContainer);



// WEBPACK FOOTER //
// ./src/containers/BabyEditContainer.js